import axios from "axios";
import { connect } from "react-redux";
import { useState, useEffect } from "react";
import { API_URL } from "../../../constants/Globals";

function AdvertisingAds({ selNetworkId, loggedInUser }) {
  const { roles } = loggedInUser;
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [content, setContent] = useState("");
  const [version, setVersion] = useState(1);
  const isSuperAdmin = !!roles.find(({ name }) => name === "SUPERADMIN");

  useEffect(() => {
    if (selNetworkId) {
      setIsLoading(true);

      axios
        .get(`${API_URL}/admin/client/${selNetworkId}/advertisingText`)
        .then(({ data }) => {
          setIsLoading(false);
          setContent(data.data ? data.data.text : "");
        });
    }
  }, [version, selNetworkId]);

  return (
    <>
      <div className="page-headline">
        <div>
          <strong>Advertising</strong>&nbsp;|&nbsp;Ads.txt
        </div>
      </div>
      <div className="mega-form">
        <div className="mega-form-top">
          <span
            className="text-button"
            onClick={() => {
              const element = document.createElement("a");
              element.setAttribute(
                "href",
                "data:text/plain;charset=utf-8," + encodeURIComponent(content),
              );
              element.setAttribute("download", "ads.txt");
              element.style.display = "none";
              document.body.appendChild(element);
              element.click();
              document.body.removeChild(element);
            }}
          >
            Download ads.txt
          </span>
        </div>
        <div className="mega-form-middle">
          <textarea
            value={content}
            onChange={({ target }) => {
              if (isSuperAdmin) {
                setContent(target.value);
              }
            }}
          ></textarea>
        </div>
        {isSuperAdmin ? (
          <div className="mega-form-bottom">
            {isLoading ? (
              <em>Please wait...</em>
            ) : (
              <>
                <button
                  className="blue-button size-l gray"
                  onClick={() => setVersion(version * 2)}
                >
                  Cancel
                </button>
                <button
                  className="blue-button size-l"
                  onClick={() => {
                    if (!isLoading) {
                      setIsLoading(true);

                      axios
                        .post(`${API_URL}/admin/client/advertisingText`, {
                          clientId: selNetworkId,
                          text: content,
                        })
                        .then(({ data }) => {
                          setIsLoading(false);
                          setSuccessMessage(
                            "The changes were successfully saved",
                          );
                          setTimeout(() => setSuccessMessage(""), 2500);
                        })
                        .catch(() => setIsLoading(false));
                    }
                  }}
                >
                  Save
                </button>
              </>
            )}
          </div>
        ) : null}
      </div>
      {successMessage ? <div className="success">{successMessage}</div> : null}
    </>
  );
}

const mapStateToProps = (state) => ({
  loggedInUser: state.login.user,
  selNetworkId: state.networks.selNetworkId,
});

export default connect(mapStateToProps, {})(AdvertisingAds);
